<template lang="pug">
	
	.loader
		.letters
			.letter(data-type='ALPHA')
				span.curr Z
				span.next Z
			.letter(data-type='NUM')
				span.curr 6
				span.next 6
			.letter(data-type='ALPHA')
				span.curr I
				span.next I
			.letter(data-type='ALPHA')
				span.curr M
				span.next M
			.letter(data-type='SPE')
				span.curr G
				span.next G
			.letter(data-type='SPE')
				span.curr S
				span.next S

		.pct
			p {{perc}} %

		
</template>


<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import Scrollable from '../abstracts/scrollable.js'
	import AssetsLoader from '../utils/assetsLoader.js'
	import Assets from './assets.json'

	import $ from 'jquery'
	import { TweenMax } from 'gsap'

	
  	@Component({
		name: 'Loader',
		props: [],
		components: { },
		data: function () {
			return {
				perc : 0,
				letters:'B4DA$$'
			}
		}
	})


	class Loader extends Scrollable {

		mounted () {
			super.mounted()

			this.progressValue = {value:0}
			this.progressTween = null
			this.loaded = false
			this.ready = false
			
			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()

			this.onLoaded = this._loaded.bind(this)
			this.progress = this._progress.bind(this)
			
		}


		load () {

			const $letters = this.$el.querySelectorAll('.letter')
			const final = "B4DA$$"
			const DURATION = 300

			const MAX = 2500

			let letters = []

			$letters.forEach( (l,i) => {
				const letter = {
					type: l.dataset.type,
					delay: Math.random() * (1.8 - .8) + .8,
					el: l,
					totalTime: 0,
					curr: l.querySelector('.curr'),
					next: l.querySelector('.next'),
					timeline: null,
					readyToStop: false
				}

				letters.push(letter)
			})

			TweenMax.to($letters,.6,{opacity:1, ease: Power3.easeIn, delay:.4, onComplete:()=>{
				AssetsLoader.loadAll(Assets.assets,this.onLoaded,this.progress)
			}})

			letters.forEach( (l,i) => {

				l.next.innerText = this.getRandomLetter(l.type)
				
				TweenMax.to([l.curr,l.next],DURATION/1000,{y:'-100%', ease:Power4.easeInOut, delay: l.delay, onComplete: ()=> {
			
					this.resetLetter(l.curr,l.next,l.type)

					l.timeline = new TimelineMax({delay:.1,repeat:-1, onRepeat:()=>{
							
 							this.resetLetter(l.curr,l.next,l.type)
							l.totalTime += DURATION + 100
							
							if(l.readyToStop) {
								l.timeline.stop()

								if(i === letters.length - 1) {
									window.setTimeout(()=>{
										this.$events.emit('app.loaded')
									},DURATION)
									TweenMax.to(this.$pct,1.2,{autoAlpha:0, delay:.5})
									TweenMax.to(this.$el.querySelector('.letters'),2,{scaleY:1.6,delay:.7,ease: Strong.easeInOut,onComplete:()=>{
										this.$el.style.display = 'none'
									}})
								}
							}
							if(l.totalTime >= MAX && this.loaded && !l.readyToStop && this.ready){
								l.readyToStop = true
								l.next.innerText = final[i]
							}	
						}	
					})
					l.timeline.to([l.curr,l.next],DURATION/1000,{y:'-100%', ease:Power4.easeInOut})
				}})
			})
		}

		resetLetter (curr, next,type) {
			curr.innerText = next.innerText
			TweenMax.set([curr,next],{y:'0%'})
			next.innerText = this.getRandomLetter(type)
		}

		getRandomLetter (type) {
			const CHARS = {
				ALPHA : 'ABCDEFGHIJKLMNOPRSTUVWXYZ',
				NUM : '0123456789',
				SPE : '&$!?£€æê®î∂‹©ß'
			}

			return CHARS[type].charAt(Math.floor(Math.random() * CHARS[type].length))
		}

		_loaded () {
			this.loaded = true
		}

		_progress (e) {

			const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789&$+-*'
			const alphaArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
			const numberArray = '0123456789'
			const specialArray = '&$+-*!?¥'

			TweenMax.to(this.progressValue,4,{value: e.amount, onUpdate:()=>{
				let ratio = this.progressValue.value * 100 / e.length
				this.perc = Math.round(ratio)
			}, onComplete: ()=> {
				this.ready = true
			}})

		}



		_dom () {
			this.$bgLetterList = this.$el.querySelectorAll('.background-letters .list')
			this.$loadingLetterList = this.$el.querySelectorAll('.loading-letters .list')
			this.$loadingLetter = this.$el.querySelectorAll('.loading-letters')
			this.$pct = this.$el.querySelector('.pct')
		}

		_resize () {
			super._resize()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default Loader

</script>

<style lang="stylus" scoped>

	@import '../theme/variables'
	@import '../theme/utils'

	.loader
		position fixed
		background-color transparent
		height 100vh
		width 100vw
		z-index 100
		display flex
		justify-content center
		align-items center
		overflow hidden

		.letters
			display flex
			height 190px
			align-items center
			overflow hidden
			

			.letter

				height 190px
				width 150px
				text-align center
				opacity 0

				span
					font-size 230px
					font-family $FONT_SECONDARY
					color #fff
					display block
					line-height 190px
					will-change transform

		.pct
			position absolute
			bottom 10vh
			left 50%
			transform translate(-50%,0,0)
			color #fff
			text-align center
			opacity .6

			p
				font-size 14px
				letter-spacing .15em
				font-family $FONT_SECONDARY
				text-transform uppercase

			
		.loader-wrapper
			height 80px
			overflow hidden
			position relative
			display flex
			width 122px
			
			.background-letters
				position relative
				height 80px
				width 100%
				bottom 0
				left 0
				overflow hidden
				p
					opacity .3

				.list
					position absolute
					bottom 0
					left 0

			.loading-letters
				height 0px
				width 100%
				overflow hidden
				position absolute
				bottom 0
				left 0

				.list
					position absolute
					bottom 0
					left 0


</style>


// WEBPACK FOOTER //
// loader.vue?8759704c